import * as types from './types';

const INITIAL_STATE = {
  loadingHACCP: false,
  savedHACCP: false,
  deleteHACCP: false,
  HACCP: [],

  loadingHACCPType: false,
  savedHACCPType: false,
  deleteHACCPType: false,
  HACCPType: [],

  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.WRITE_HACCP_LOADING:
      return {
        ...state,
        loadingHACCP: action.payload,
        savedHACCP: false,
      };

    case types.GET_HACCP_LOADING:
      return {
        ...state,
        loadingHACCP: action.payload,
      };

    case types.GET_HACCP_TYPE_LOADING:
      return {
        ...state,
        loadingHACCPType: action.payload,
      };

    case types.WRITE_HACCP_TYPE_LOADING:
      return {
        ...state,
        loadingHACCPType: action.payload,
        savedHACCPType: false,
      };

    case types.WRITE_HACCP_SUCCESS:
      return {
        ...state,
        savedHACCP: true,
        HACCP: action.payload,
      };
    case types.GET_HACCP_SUCCESS:
      return {
        ...state,
        HACCP: action.payload,
      };
    case types.WRITE_HACCP_TYPE_SUCCESS:
      return {
        ...state,
        savedHACCPType: true,
        HACCPType: action.payload,
      };

    case types.DELETE_HACCP_TYPE_LOADING:
      return {
        ...state,
        loadingHACCPType: action.payload,
        deleteHACCPType: false,
      };
    case types.DELETE_HACCP_TYPE_SUCCESS:
      return {
        ...state,
        deleteHACCPType: true,
        HACCPType: action.payload,
      };
    case types.DELETE_HACCP_LOADING:
      return {
        ...state,
        deleteHACCP: false,
        loadingHACCP: action.payload,
      };
    case types.DELETE_HACCP_SUCCESS:
      return {
        ...state,
        deleteHACCP: true,
        HACCP: action.payload,
      };
    case types.GET_HACCP_TYPE_SUCCESS:
      return {
        ...state,
        HACCPType: action.payload,
      };

    case types.GET_HACCP_ERROR:
    case types.WRITE_HACCP_TYPE_ERROR:
    case types.WRITE_HACCP_ERROR:
    case types.GET_HACCP_TYPE_ERROR:
    case types.DELETE_HACCP_TYPE_ERROR:
    case types.DELETE_HACCP_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/haccp/reducer.js